<div class="row">
  <div class="col-3">
    <h1><strong>Użytkownicy</strong></h1>
  </div>
  <div class="col-9">
    <div class="float-right">
      <button mat-raised-button color="primary" routerLink="/management/user-add/"
        [state]="{page: paginator.pageIndex,pageSize: paginator.pageSize}">
        Dodaj
      </button>
      <button [disabled]="selection.selected.length != 1" class="ml-1" mat-raised-button color="accent"
        (click)="edit()">
        Edytuj
      </button>
      <!-- <button [disabled]="selection.selected.length != 1" class="ml-1" mat-raised-button color="warn" (click)="delete()">
                Usuń
            </button> -->
      <button [disabled]="selection.selected.length != 1" class="ml-1" mat-raised-button color="primary"
        (click)="details()">
        Szczegóły
      </button>
    </div>
  </div>
</div>

<mat-form-field class="w-100">
  <mat-label>Filtr</mat-label>
  <input matInput (keyup)="applyFilter($event)" placeholder="Wyszukaj..." #input>
</mat-form-field>
<div class="mat-elevation-z8">

  <table class="w-100" mat-table matSort [dataSource]="dataSource">
    <caption></caption>
    <ng-container matColumnDef="select">
      <th scope="col" mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header [hidden]=production>Id</th>
      <td mat-cell *matCellDef="let element" [hidden]=production> {{element.id}} </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>Imię i nazwisko</th>
      <td mat-cell *matCellDef="let element"> {{ (element?.firstName || '')  + ' ' + (element?.lastName || '') }} </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
      <td mat-cell *matCellDef="let element"> {{element?.email}} </td>
    </ng-container>

    <ng-container matColumnDef="companyName">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>Firma</th>
      <td mat-cell *matCellDef="let element"> {{element?.companyName}} </td>
    </ng-container>

    <ng-container matColumnDef="emailConfirmed">
      <th scope="col" mat-header-cell *matHeaderCellDef>Aktywny</th>
      <td mat-cell *matCellDef="let element">
        <mat-icon style="color:green;text-align:center;" *ngIf="element.emailConfirmed">done</mat-icon>
        <mat-icon style="color:red;text-align:center;" *ngIf="!element.emailConfirmed">clear</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="personConnection">
      <th scope="col" mat-header-cell *matHeaderCellDef>Powiązanie</th>
      <td mat-cell *matCellDef="let element">
        <mat-icon style="color:green;text-align:center;" *ngIf="element.personId > 0">done</mat-icon>
        <mat-icon style="color:red;text-align:center;" *ngIf="element.personId <= 0">clear</mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)">
    </tr>
  </table>
  <mat-paginator [pageSizeOptions]="[5, 10, 15, 20]" [pageSize]="10" showFirstLastButtons #paginator></mat-paginator>
</div>
